class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/* Keep product megamenus within viewport on desktop */
(function clampProductMegamenus() {
  const selector = '.submenu-container.submenu--product-megamenu';
  const padding = 12;

  function clampForItem(item) {
    const menu = item.querySelector('.mega-menu-products-shell');
    if (!menu) return;

    menu.style.setProperty('--megamenu-x-offset', '0px');

    const rect = menu.getBoundingClientRect();
    const overflowRight = rect.right - (window.innerWidth - padding);
    const overflowLeft = padding - rect.left;

    let offset = 0;
    if (overflowRight > 0) offset = -overflowRight;
    else if (overflowLeft > 0) offset = overflowLeft;

    if (offset !== 0) {
      menu.style.setProperty('--megamenu-x-offset', `${offset}px`);
    }
  }

  function bindItem(item) {
    const handler = () => requestAnimationFrame(() => clampForItem(item));
    item.addEventListener('mouseenter', handler);
    item.addEventListener('focusin', handler);
  }

  function init() {
    document.querySelectorAll(selector).forEach(bindItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll(selector).forEach((item) => {
      if (item.matches(':hover')) clampForItem(item);
    });
  });
})();
